
import { ref } from 'vue'
import { getI18n } from '@/plugins/i18n'

import { useWebSiteStore } from '@/stores/web-site.store'

export const useClipboard = () => {
  const i18n = getI18n()

  const webSiteStore = useWebSiteStore()

  const clipboardExportToolbarButton = {}
  const clipboardExportDialogVisible = ref(false)

  const getClipboardItems = (options = {}) => {
    return [
      { ...{ source: webSiteStore.importRowTypesEnum.CLIPBOARD, text: i18n.t('common.importFromClipboard') }, ...options }
    ]
  }

  const clipboardExportToolbarWidget = (options = null) => ({
    widget: 'dxButton',
    location: 'after',
    options: { ...{
      icon: 'mdi mdi-clipboard-arrow-right-outline mdi-18px',
      disabled: true,
      hint: i18n.t('common.exportToClipboard'),
      onClick: () => { clipboardExportDialogVisible.value = true },
      onInitialized: (e) => { clipboardExportToolbarButton.value = e.component }
    }, ...options }
  })

  return { getClipboardItems, clipboardExportToolbarWidget, clipboardExportToolbarButton, clipboardExportDialogVisible }
}
